module.exports = __webpack_public_path__ + "static/parade-2019-house16-4b3b69e8e8079821c7614313bac1d2cd.jpg";